
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Ertigaonrentinmumbai() {



    const cardData =
    {
        keyword: ' Ertiga On Rent in Mumbai',
        heading: 'Skyline Cabs:  Ertiga On Rent in Mumbai',
        headingDescription: '​Skyline Cabs offers comfortable and reliable Ertiga on Rent in Mumbai services for a versatile and budget-friendly travel experience. Whether you are planning a family outing, corporate trip, or a special event, our well-maintained Ertiga vehicles and professional drivers ensure a smooth and enjoyable ride. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Ertiga rental with Skyline Cabs today and travel in comfort and style across Maharashtra and beyond!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Ertiga on Rent in Mumbai",
      "description": "Skyline Cabs offers Ertiga on rent in Mumbai for city and outstation travel. A perfect choice for families or small groups looking for comfort and space."
    },
    {
      "name": "Mumbai Ertiga Hire for Outstation",
      "description": "Planning an outstation trip? Hire an Ertiga from Skyline Cabs in Mumbai for a smooth, spacious, and economical travel experience."
    },
    {
      "name": "Rent 7 Seater Ertiga in Mumbai",
      "description": "Book a 7-seater Ertiga in Mumbai with Skyline Cabs. Ideal for group travel, family tours, and long-distance rides with ample comfort."
    },
    {
      "name": "Ertiga Rental Mumbai",
      "description": "Skyline Cabs provides flexible and affordable Ertiga rental options in Mumbai. Enjoy a clean, reliable vehicle with professional service."
    },
    {
      "name": "Ertiga Hire for Family Trip",
      "description": "Make your family trip more enjoyable with Skyline Cabs' Ertiga rental service. Spacious, safe, and ideal for group journeys."
    },
    {
      "name": "Ertiga for Corporate Event in Mumbai",
      "description": "Hire an Ertiga for your corporate event in Mumbai with Skyline Cabs. Efficient transport for your team or guests, with comfort and reliability."
    }
  ],
  "tableData": [
    ["Ertiga on Rent in Mumbai", "Mumbai Ertiga Hire for Outstation"],
    ["Rent 7 Seater Ertiga in Mumbai", "Ertiga Rental Mumbai"],
    ["Ertiga Hire for Family Trip", "Ertiga for Corporate Event in Mumbai"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Ertiga on Rent in Mumbai",
      "WhyChoosedescription": "Book the reliable and fuel-efficient Maruti Suzuki Ertiga in Mumbai for your travel needs. Ideal for family trips, airport transfers, and outstation journeys."
    },
    {
      "WhyChooseheading": "Comfortable 7-Seater for Family and Group Travel",
      "WhyChoosedescription": "The Ertiga offers spacious seating for up to 7 passengers, making it a perfect choice for small groups, families, and team outings."
    },
    {
      "WhyChooseheading": "Perfect for City Rides and Outstation Trips",
      "WhyChoosedescription": "Whether you're traveling within Mumbai or heading out of town, the Ertiga delivers comfort, reliability, and great mileage every time."
    },
    {
      "WhyChooseheading": "Modern Features and Efficient Performance",
      "WhyChoosedescription": "Equipped with air conditioning, USB ports, reclining seats, and a smooth drive—Ertiga combines practicality with convenience."
    },
    {
      "WhyChooseheading": "Trained and Polite Chauffeurs",
      "WhyChoosedescription": "Our experienced drivers ensure a safe, comfortable, and on-time journey with courteous service from pickup to drop-off."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicle",
      "WhyChoosedescription": "Each Ertiga is regularly cleaned and sanitized to maintain hygiene and comfort standards for every ride."
    },
    {
      "WhyChooseheading": "Affordable and Flexible Rental Packages",
      "WhyChoosedescription": "Choose from multiple rental plans—hourly, daily, or long-term—customized to fit your budget and travel requirements in Mumbai."
    },
    {
      "WhyChooseheading": "24/7 Booking and Support",
      "WhyChoosedescription": "Book your Ertiga anytime through our user-friendly online platform or by calling our 24/7 customer service for quick assistance."
    }
  ]
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent an Ertiga in Mumbai with Skyline Cabs?',
            answer:
                'Renting an Ertiga in Mumbai is super simple. You can book through our website, mobile app, or by calling our customer support. Just share your pickup location, date, and type of trip to get started.',
        },
        {
            id: 2,
            question: 'How many passengers can the Ertiga accommodate?',
            answer:
                'The Ertiga can comfortably seat up to 6 passengers plus the driver. It’s ideal for small families, airport transfers, and local or outstation travel.',
        },
        {
            id: 3,
            question: 'Is the Ertiga good for long-distance travel from Mumbai?',
            answer:
                'Yes, the Ertiga is a great option for long-distance journeys. It offers good fuel efficiency, ample legroom, and a smooth ride—perfect for both city and outstation trips.',
        },
        {
            id: 4,
            question: 'Are the rental prices for Ertiga in Mumbai fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing. Your fare includes the vehicle, driver charges, fuel, tolls, and taxes. You’ll see the total cost upfront before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book the Ertiga for hourly or full-day rental?',
            answer:
                'Absolutely. You can rent the Ertiga for hourly use, a full day, or for multi-day trips. Just let us know your travel plans and we’ll tailor the rental package accordingly.',
        },
        {
            id: 6,
            question: 'Is the Ertiga air-conditioned and comfortable?',
            answer:
                'Yes, all our Ertiga vehicles are air-conditioned, well-maintained, and offer a smooth and comfortable ride for all passengers.',
        },
        {
            id: 7,
            question: 'Can I rent an Ertiga for corporate or event travel?',
            answer:
                'Yes, the Ertiga is a great choice for corporate transfers, small group events, or wedding transportation. We provide clean vehicles and professional drivers for every occasion.',
        },
        {
            id: 8,
            question: 'What payment options are available for renting an Ertiga?',
            answer:
                'We accept UPI, credit/debit cards, net banking, and cash. All online payments are secure and booking confirmations are sent via SMS and email.',
        },
        {
            id: 9,
            question: 'Can I cancel or change my Ertiga booking?',
            answer:
                'Yes, you can cancel or modify your Ertiga booking anytime through our website, app, or by contacting our support team. We offer flexible policies for your convenience.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Ertiga rental in Mumbai?',
            answer:
                'Skyline Cabs provides clean and reliable Ertiga rentals at affordable prices. With trained drivers, transparent billing, and excellent customer service, we ensure your ride is smooth and worry-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Akshay Patil",
            rating: 5,
            review: "Booked an Ertiga for a family trip to Lonavala. The car was clean and comfortable, and our driver was very friendly and punctual. Really good experience with Skyline Cabs!"
        },
        {
            name: "Mrs. Nidhi Rane",
            rating: 4,
            review: "We used Skyline’s Ertiga for airport pickup and it was very convenient. The vehicle was in great condition. Just a little late on arrival but everything else was smooth."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Mumbai",
  "image": "https://skylinecabs.com/assets/images/ertiga-on-rent-mumbai.jpg",
  "description": "Book Ertiga on rent in Mumbai with Skyline Cabs for affordable and comfortable group travel. Ideal for family trips, corporate rides, and airport transfers. Spacious 6/7 seater Ertiga available with AC, pushback seats, and trained drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8419"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/ertiga-on-rent-in-mumbai"
  }
};


      


    return (
        <div>


<Helmet>
  <title>Ertiga On Rent in Mumbai | Affordable 6,7 Seater SUV Hire | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Ertiga on rent in Mumbai with Skyline Cabs for affordable and comfortable group travel. Ideal for family trips, corporate rides, and airport transfers. Spacious 6/7 seater Ertiga available with AC, pushback seats, and trained drivers." 
  />
  <meta 
    name="keywords" 
    content="Ertiga On Rent in Mumbai, 6 Seater Ertiga SUV Hire Mumbai, 7 Seater Ertiga Cab Mumbai, Mumbai Airport Ertiga Booking, Outstation SUV Rental Mumbai, AC Ertiga with Driver, Family SUV Cab Mumbai, Skyline Cabs Ertiga Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/92.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ertigaonrentinmumbai;